<template>
  <div></div>
  <Mask v-if="showMask" />
  <component v-bind:is="content"></component>
</template>
<style scoped>
.el-main {
  color: #333;
  padding: 10px 10px;
}
</style>
<script setup>
import { ref, toRaw, provide, reactive, shallowRef, defineEmits, onBeforeMount } from "vue";
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import * as constants from '@/utils/constants'
import Mask from '@/components/Mask.vue'
import Binance from "@/components/crypto/binance/Index.vue"
import Okx from "@/components/crypto/okx/Index.vue"

const systemStore = useSystemStore()
const logStore = useLogStore()
const showMask = ref(true)
const content = shallowRef(null)

onBeforeMount(async () => {
  if (systemStore.platform === constants.BINANCE) {
    await initBinanceData()
    return
  }

  if (systemStore.platform === constants.OKX) {
    await initOkxData()
    return
  }
})

const initBinanceData = async () => {
  try {

    showMask.value = true

    // 交易所全部合约交易对
    const markets = await systemStore.publicClient.exchangeInfo()

    console.log('markets', markets)
    const usdtMarkets = markets.symbols.filter(m => (m.contractType === "PERPETUAL" || m.contractType === "TRADIFI_PERPETUAL") && m.quoteAsset === "USDT")

    // 获取账户的持仓信息（包含杠杆和保证金模式）
    const postionRisk = await systemStore.privateClient.positionsV2()

    // 自定义合约交易对
    const usymbols = usdtMarkets.map((item) => {
      let _position = postionRisk.find(p => p.symbol === item.symbol)
      return {
        name: item.symbol,
        symbol: item.symbol,
        info: item,
        binanceConfig: {
          leverage: _position ? _position.leverage : 0,
          marginType: _position ? _position.marginType : constants.CROSS,
        },
        okxConfig: {
          marginType: constants.CROSS,
          crossLongLeverage: 0,
          crossShortLeverage: 0,
          isolatedLongLeverage: 0,
          isolatedShortLeverage: 0,
        },
        iscollect: false,
        ascnumber: 0
      }
    })

    // 自定义默认选中交易对
    let btcusdt = usymbols.find(m => m.symbol === "BTCUSDT")
    let _default = {
      name: btcusdt.name,
      symbol: btcusdt.symbol,
      info: btcusdt.info,
      binanceConfig: {
        leverage: btcusdt.binanceConfig.leverage,
        marginType: btcusdt.binanceConfig.marginType
      },
      okxConfig: {
        marginType: constants.CROSS,
        crossLongLeverage: 0,
        crossShortLeverage: 0,
        isolatedLongLeverage: 0,
        isolatedShortLeverage: 0,
      },
    }
    systemStore.setExchangeInfo(markets)
    systemStore.setUExchangeInfo(usdtMarkets)
    systemStore.setUSymbols(usymbols)
    systemStore.setCurrentusymbol(_default)

    content.value = Binance
    showMask.value = false
  } catch (error) {
    console.log(error)
    showMask.value = false
    logStore.addLog({
      title: '初始化 Binance 数据失败',
      level: 'error',
      message: error
    })
  }
}

const initOkxData = async () => {
  try {
    showMask.value = true
    const markets = await systemStore.publicClient.getInstruments()
    const usdtMarkets = markets.filter(m => m.instType === "SWAP" && m.settleCcy === "USDT" && m.state === "live")

    // 自定义合约交易对
    const usymbols = usdtMarkets.map((item) => {
      return {
        name: item.instId.replace(/-USDT-SWAP$/, "USDT").replace(/-/g, ""),
        symbol: item.instId,
        amount: item.lotSz,
        price: item.tickSz,
        info: item,
        binanceConfig: {
          leverage: 0,
          marginType: constants.CROSS,
        },
        okxConfig: {
          marginType: constants.ISOLATED, //默认逐仓
          crossLongLeverage: 0,
          crossShortLeverage: 0,
          isolatedLongLeverage: 0,
          isolatedShortLeverage: 0,
        },
        iscollect: false,
        ascnumber: 0
      }
    })

    //自定义默认选中交易对
    let btcusdt = usymbols.find(m => m.symbol === "BTC-USDT-SWAP")

    let _default = {
      name: btcusdt.name,
      symbol: btcusdt.symbol,
      amount: btcusdt.amount,
      price: btcusdt.price,
      binanceConfig: {
        leverage: 0,
        marginType: constants.CROSS,
      },
      okxConfig: {
        marginType: constants.ISOLATED,
        crossLongLeverage: 0,
        crossShortLeverage: 0,
        isolatedLongLeverage: 0,
        isolatedShortLeverage: 0,
      },
    }

    systemStore.setExchangeInfo(markets)
    systemStore.setUExchangeInfo(usdtMarkets)
    systemStore.setUSymbols(usymbols)
    systemStore.setCurrentusymbol(_default)

    content.value = Okx
    showMask.value = false
  } catch (error) {
    console.log(error)
    showMask.value = false
    logStore.addLog({
      title: '初始化 Okx 数据失败',
      level: 'error',
      message: error
    })
  }
}

const dashboardActions = {
  openLoading: () => showMask.value = true,
  closeLoading: () => showMask.value = false,
}

provide("dashboardActions", dashboardActions)

</script>
